export default __webpack_public_path__ + "static/media/Ballroll_00353.96f633b5.png";